type ReadMoneykitInstitutionNameParams = {
  readonly selectedName?: string | null;
  readonly providerName?: string | null;
  readonly institutionName?: string | null;
  readonly linkedName?: string | null;
};

function isJsonRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function readStringField(value: unknown, key: string) {
  if (!isJsonRecord(value)) return null;
  const field = value[key];
  return typeof field === 'string' ? field : null;
}

export function readMoneykitConnectEventInstitutionName(event: Record<string, unknown>) {
  if (event['name'] !== 'select_institution') return null;
  return readMoneykitInstitutionName({
    selectedName: readStringField(event['properties'], 'institution_name'),
    linkedName: readStringField(event['meta'], 'institution_name'),
  });
}

export function readMoneykitInstitutionName({
  selectedName,
  providerName,
  institutionName,
  linkedName,
}: ReadMoneykitInstitutionNameParams) {
  // MoneyKit sandbox mock banks keep a user-facing name on select_institution
  // and in the SDK; fetch_link / continue often report the underlying "OAuth Bank".
  const candidates = [selectedName, linkedName, institutionName, providerName];
  for (const candidate of candidates) {
    if (candidate === undefined || candidate === null) continue;
    const trimmed = candidate.trim();
    if (trimmed.length > 0) return trimmed;
  }
  return null;
}
